/* eslint-disable */
export default {
  callerCall: 'Beller',
  transferCall: 'Doorverbinden',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
